module.exports = __webpack_public_path__ + "static/media/empty_notifications_tabby.0096e975.png";